// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const ClipboardCheckIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "ClipboardCheck/outline"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M9.707 13.293a1 1 0 0 0-1.414 1.414l1.414-1.414ZM11 16l-.707.707a1 1 0 0 0 1.414 0L11 16Zm4.707-3.293a1 1 0 0 0-1.414-1.414l1.414 1.414ZM18 7v12h2V7h-2Zm-1 13H7v2h10v-2ZM6 19V7H4v12h2ZM7 6h2V4H7v2Zm8 0h2V4h-2v2ZM7 20a1 1 0 0 1-1-1H4a3 3 0 0 0 3 3v-2Zm11-1a1 1 0 0 1-1 1v2a3 3 0 0 0 3-3h-2Zm2-12a3 3 0 0 0-3-3v2a1 1 0 0 1 1 1h2ZM6 7a1 1 0 0 1 1-1V4a3 3 0 0 0-3 3h2Zm2.293 7.707 2 2 1.414-1.414-2-2-1.414 1.414Zm3.414 2 4-4-1.414-1.414-4 4 1.414 1.414ZM11 4h2V2h-2v2Zm2 2h-2v2h2V6Zm-2 0a1 1 0 0 1-1-1H8a3 3 0 0 0 3 3V6Zm3-1a1 1 0 0 1-1 1v2a3 3 0 0 0 3-3h-2Zm-1-1a1 1 0 0 1 1 1h2a3 3 0 0 0-3-3v2Zm-2-2a3 3 0 0 0-3 3h2a1 1 0 0 1 1-1V2Z"
}));
export default ClipboardCheckIcon;